import React from 'react';
import '../css/button.css';
import Scrollme from './Scrollme';
const Button = (props) => {
    let className = props.className;
    return (
      <button className={className} onClick={() => Scrollme(props.id)}>{props.name}</button>
    );
  };
  
  export default Button;